<template>
    <div
        class="fx-col fx-c_stretch"
        v-loading="loading"
        element-loading-text="数据加载中，请等待..."
    >
   <!-- <div class="mask" v-if="authorize">
    	<div style="margin-top: 150px;margin-left: 600px;opacity: 0.7;">
    		<img src="./watermark.png" style="height: 400px;width: 400px;" />
    		<br/>
    		<h1 style="opacity: 0.7;">暂未授权,请联系相关工作人员</h1>
    	</div>
    </div> -->
        <div class="title fx fx-center ">
            <i class="iconfont icon-banji1 text_primary font20"></i>
            班级：
            <el-dropdown trigger="hover" @command="handleClassChange">
                <el-button type="primary">
                    {{ currentClass.name
                    }}<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item
                        v-for="item in classes"
                        :key="item.id"
                        :command="item.id"
                        >{{ item.name }}
                    </el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>

        <div class="fx-g1 fx fx-c_stretch">
            <!-- 班级的课程列表 -->
            <div
                class="lesson_nav fx-col fx-c_stretch"
                :class="{ shrink: navShrink }"
            >
                <div class="fx fx-m_between fx-c_center font16">
                    <span
                        style="display: block;max-width: 230px;"
                        class="ellipsis"
                    >
                        <i class="iconfont icon-tushu font20 text_primary"></i>
                        <span class="shrink"
                            >{{ currentClass.name }}课程列表</span
                        >
                    </span>
                    <el-button size="mini" type="danger" @click="startAllLessons()">一键开课</el-button>
                </div>
                <div class="fx-g1 lesson_list shrink" ref="lesson_list">
                    <div
                        v-for="item in classLessons"
                        :key="item.id"
                        :ref="'lesson_item' + item.id"
                        class="lesson_item fx fx-m_between fx-c_center"
                        @click="changeClassLesson(item)"
                        :class="{ active: item.id == classLessonId }"
                    >
                        <span class="lesson_item-name ellipsis">{{
                            item.lessonName
                        }}</span>
                        <i
                            class="iconfont"
                            :class="{
                                'icon-duihao': item.state == 3,
                                'icon-shijian': item.state != 3,
                                state1: item.state == 1,
                                state2: item.state == 2,
                                state3: item.state == 3
                            }"
                        ></i>
                    </div>
                </div>
                <div
                    class="nav_control fx fx-center"
                    @click.stop="navShrink = !navShrink"
                >
                    <el-tooltip
                        v-if="navShrink == false"
                        class="item"
                        effect="dark"
                        content="点击收起"
                        placement="top-start"
                    >
                        <i class="el-icon-arrow-left font20 bold"></i>
                    </el-tooltip>
                    <el-tooltip
                        v-if="navShrink"
                        class="item"
                        effect="dark"
                        content="点击展开"
                        placement="top-start"
                    >
                        <i class="el-icon-arrow-right font20 bold"></i>
                    </el-tooltip>
                </div>
            </div>
            <div class="fx-g1 fx-col fx-c_stretch" style="margin-left: 6px">
                <div class="lesson_panel fx fx-c_stretch ">
                    <div
                        class="lesson_info fx-g1 fx-col"
                        style="margin-right: 6px;border-radius: 6px"
                    >
                        <span class="font16" style="margin-bottom: 15px">{{
                            currentLesson.lessonName
                        }}</span>
                        <div class="fx fx-m_start fx-c_start">
                            <el-image
                                style="width: 430px; height: 270px"
                                :src="currentLesson.lessonCoverImg"
                                :preview-src-list="[
                                    currentLesson.lessonCoverImg
                                ]"
                                fit="fill"
                            ></el-image>
                            <div
                                class="fx-g1"
                                style="margin-left: 15px;padding-top: 15px"
                            >
                                <span class="font16">课程介绍：</span>
                                <p>{{ currentLesson.introduction }}</p>
                            </div>
                        </div>
                        <div
                            class="fx fx-m_between fx-c_center"
                            style="margin-top: 15px"
                            v-if="currentLesson.id"
                        >
                            <div class="fx fx-m_start fx-c_center">
                                <el-button
                                    v-if="
                                        currentLesson.videos &&
                                            currentLesson.videos.length > 0
                                    "
                                    type="primary"
                                    size="small"
                                    @click="
                                        setShowResources(currentLesson.videos)
                                    "
                                    ><i class="iconfont icon-shipin"></i>
                                    查看视频
                                </el-button>
                                <el-button
                                    v-if="
                                        currentLesson.plans &&
                                            currentLesson.plans.length > 0
                                    "
                                    type="primary"
                                    size="small"
                                    @click="
                                        setShowResources(currentLesson.plans)
                                    "
                                    ><i class="iconfont icon-commonfile"></i>
                                    查看教案
                                </el-button>
                                <el-button
                                    type="primary"
                                    size="small"
                                    @click="
                                        setShowMyResources(
                                            currentLesson.myPlans
                                        )
                                    "
                                    ><i class="iconfont icon-user"></i> 我的教案
                                </el-button>
                                <el-button
                                    v-if="
                                        currentLesson.ppts &&
                                            currentLesson.ppts.length > 0
                                    "
                                    type="primary"
                                    size="small"
                                    @click="
                                        setShowResources(currentLesson.ppts)
                                    "
                                    ><i class="iconfont icon-ppt"></i> 查看PPT
                                </el-button>
                                <el-button
                                    v-if="
                                        currentLesson.codes &&
                                            currentLesson.codes.length > 0
                                    "
                                    type="primary"
                                    size="small"
                                    @click="viewCode(currentLesson.codes[0].id)"
                                    ><i class="iconfont icon-code"></i> 查看代码
                                </el-button>
                            </div>
                            <div>
                                <el-button
                                    type="warning"
                                    size="small"
                                    @click="toCode()"
                                    ><i
                                        class="iconfont icon-zhongchuangkongjian-"
                                    ></i>
                                    去创作
                                </el-button>
                                <el-popconfirm
                                    @onConfirm="copyLesson()"
                                    v-if="currentLesson.state == 3"
                                    title="确认要重新开课吗？"
                                    style="margin-left: 15px"
                                >
                                    <el-button slot="reference" type="primary"
                                        >重新开课</el-button
                                    >
                                </el-popconfirm>
                            </div>
                        </div>
                    </div>
                    <div class=" fx-col fx-c_stretch">
                        <div
                            class="fx-g1 fx-col fx-center lesson_opt"
                            style="margin-bottom: 6px"
                        >
                            <template v-if="this.currentLesson.id">
                                <span
                                    style="font-size: 20px;margin-bottom: 25px"
                                >
                                    <i
                                        class="iconfont icon-shijian text_primary font24"
                                        style="font-weight: bold"
                                    ></i>
                                    <span style="margin-left: 10px">
                                        <template
                                            v-if="currentLesson.state != 1"
                                        >
                                            <span
                                                v-if="
                                                    currentLesson.duration
                                                        .days > 0
                                                "
                                                >{{
                                                    currentLesson.duration.days
                                                }}天
                                            </span>
                                            <span
                                                v-if="
                                                    currentLesson.duration
                                                        .hours > 0
                                                "
                                                >{{
                                                    currentLesson.duration.hours
                                                }}
                                                :
                                            </span>
                                            <span
                                                >{{
                                                    currentLesson.duration
                                                        .minutes
                                                }}
                                                :
                                            </span>
                                            <span>{{
                                                currentLesson.duration.seconds
                                            }}</span>
                                        </template>
                                        <template
                                            v-if="currentLesson.state == 1"
                                            >00 : 00</template
                                        >
                                    </span>
                                </span>
                                <el-button
                                    v-if="currentLesson.state == 3"
                                    type="danger"
                                    style="width: 190px;height: 50px;font-size: 20px"
                                    >已结束
                                </el-button>
                                <el-button
                                    v-if="currentLesson.state == 2"
                                    @click="stopLesson"
                                    type="danger"
                                    style="width: 190px;height: 50px;font-size: 20px"
                                    >下课
                                </el-button>
                                <el-button
                                    v-if="currentLesson.state == 1"
                                    @click="startLesson"
                                    type="primary"
                                    style="width: 190px;height: 50px;font-size: 20px"
                                    >上课
                                </el-button>
                                <div
                                    class="trysn_block fx fx-center"
                                    v-if="currentLesson.state == 2"
                                >
                                    <i
                                        class="iconfont icon-yanzhengma text_primary font26"
                                    ></i
                                    >体验码：<span
                                        style="letter-spacing: 1px"
                                        >{{ currentLesson.sn }}</span
                                    >
                                </div>
                            </template>
                        </div>
                        <div class="fx-g1 fx-col fx-center lesson_opt">
                            <template v-if="this.currentLesson.id">
                                <span
                                    style="font-size: 20px;margin-bottom: 25px"
                                >
                                    <i
                                        class="iconfont icon-boshi text_primary font24"
                                        style="font-weight: bold"
                                    ></i>
                                    <span style="margin-left: 6px"
                                        >{{
                                            currentLesson.attendanceStudentCount
                                        }}
                                        /
                                        {{
                                            currentLesson
                                                ? currentLesson.studentCount +
                                                  currentLesson.tryStudentCount
                                                : ""
                                        }}</span
                                    >
                                </span>
                                <el-button
                                    type="primary"
                                    @click="showAttendanceDetail"
                                    >查看学生出勤</el-button
                                >
                            </template>
                        </div>
                    </div>
                </div>
                <div
                    class="task_panel fx-g1 fx-col"
                    style="margin-top: 6px;min-height: 100px"
                >
                    <!-- dialogTableVisible = true -->

                    <el-table
                        v-if="currentLesson.tasks"
                        :data="currentLesson.tasks"
                        height="100%"
                        stripe
                        style="width: 100%"
                    >
                        <el-table-column min-width="180" fixed label="任务名称">
                           <template slot-scope="scope">
                               {{
                                    scope.row.useType == 1
                                        ? scope.row.title
                                        : scope.row.useType == 2
                                        ? scope.row.question.questionFormHtml
                                        : scope.row.useType == 3
                                        ? scope.row.module.title
                                        : ""
                                }}
                            </template>
                            <template v-slot:header>
                                <span
                                    class="pointer fx-c_center"
                                    style="display: inline-flex"
                                    @click="openTask"
                                >
                                    <i
                                        class="iconfont icon-plus-square-fill font26 "
                                        style="margin-right: 5px;color:var(--primary);padding:0;border-radius: 28px;overflow: hidden"
                                    ></i>
                                    <span
                                        style="color: #3c3c3c;font-size: 15px;"
                                        >添加训练</span
                                    >
                                </span>
                            </template>
                        </el-table-column>
                        <el-table-column property="date" label="" width="200">
                          <template slot-scope="scope">
                                <tag-group
                                    :tags="
                                        scope.row.useType == 1
                                            ? scope.row.knowledgeArray
                                            : scope.row.useType == 2
                                            ? scope.row.question.knowledgeArray
                                            : scope.row.useType == 3
                                            ? scope.row.module.tagNames
                                            : []
                                    "
                                    size="small"
                                ></tag-group>
                            </template>
                        </el-table-column>
                        <el-table-column width="430" label="训练详情">
                            <template slot-scope="scope">
                                <div class="fx fx-m_center fx-c_center fx-wrap">
                                    <span
                                        v-if="scope.row.videos.length != 0"
                                        class="fx fx-c_center task_resource"
                                        >讲解视频:
                                        <el-link
                                            @click="
                                                setShowResources(
                                                    scope.row.videos
                                                )
                                            "
                                            type="warning"
                                            :underline="false"
                                            class="font12"
                                            ><i class="iconfont icon-shipin"></i
                                            >查看</el-link
                                        >
                                    </span>
                                    <span
                                        v-if="scope.row.attachments.length != 0"
                                        class="fx fx-c_center task_resource"
                                        >随堂资料:
                                        <el-link
                                            @click="
                                                setShowResources(
                                                    scope.row.attachments
                                                )
                                            "
                                            type="warning"
                                            :underline="false"
                                            class="font12"
                                            ><i class="iconfont icon-word"></i
                                            >查看</el-link
                                        >
                                    </span>
                                    <span
                                        v-if="scope.row.tutorials.length != 0"
                                        class="fx fx-c_center task_resource"
                                        >任务卡片:
                                        <el-link
                                            @click="
                                                setShowResources(
                                                    scope.row.tutorials
                                                )
                                            "
                                            type="warning"
                                            :underline="false"
                                            class="font12"
                                            ><i class="iconfont icon-ppt"></i
                                            >查看</el-link
                                        >
                                    </span>
                                    <span
                                        v-if="scope.row.codes.length != 0"
                                        class="fx fx-c_center task_resource"
                                        >相关代码:
                                        <el-link
                                            type="warning"
                                            @click="
                                                viewCode(scope.row.codes[0].id)
                                            "
                                            :underline="false"
                                            class="font12"
                                            ><i class="iconfont icon-word"></i
                                            >查看</el-link
                                        >
                                    </span>
                                    <span
                                        class="fx fx-c_center"
                                        v-if="scope.row.linkCodes.length != 0"
                                    >
                                        成品代码：
                                        <el-button
                                            type="text"
                                            @click="
                                                viewCode(
                                                    scope.row.linkCodes[0].id
                                                )
                                            "
                                            size="medium"
                                            class="text_warn"
                                            >查看</el-button
                                        >
                                    </span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column min-width="100" label="是否开启">
                            <template slot-scope="scope">
                                <el-switch
                                    v-model="scope.row.enable"
                                    @change="modifyTaskEnable(scope.row)"
                                    inactive-color="#ff4949"
                                >
                                </el-switch>
                            </template>
                        </el-table-column>
                        <el-table-column min-width="160" label="提交人数">
                            <template slot-scope="scope">
                                {{ scope.row.submitCount }} /
                                {{ currentLesson.studentCount }}
                            </template>
                        </el-table-column>
                        <el-table-column label="完成详情" min-width="120">
                            <template slot-scope="scope">
                                <el-button
                                    type="primary"
                                    @click="showTaskWorks(scope.row)"
                                    size="mini"
                                    >查看</el-button
                                >
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" fixed="right" width="150">
                            <template
                                slot-scope="scope"
                                v-if="scope.row.lessonSystemId == 0"
                            >
                                <el-popconfirm
                                    @onConfirm="remove(scope.row)"
                                    title="确认移除该任务吗？"
                                >
                                    <div
                                        slot="reference"
                                        class="fx fx-center pointer"
                                    >
                                        <i
                                            class="iconfont icon-minus-circle-fill font22"
                                            style="color: var(--danger)"
                                        ></i>
                                        <span class="remove_btn ">移除</span>
                                    </div>
                                </el-popconfirm>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </div>

        <template>
            <el-dialog
                title="选择添加的训练"
                :visible.sync="dialogTableVisible"
                center
                width="60%"
                style="margin-top: -11vh;"
                class="task_dialog"
            >
                <div style="margin-bottom: 10px;">
                    <!--                    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
                                            <el-tab-pane label="任务" name="task"></el-tab-pane>
                                            <el-tab-pane label="题目" name="question"></el-tab-pane>
                                            <el-tab-pane label="题库" name="train"></el-tab-pane>
                                        </el-tabs>-->
                    <el-radio-group v-model="activeName">
                        <el-radio-button label="task">任务</el-radio-button>
                        <el-radio-button label="question">题目</el-radio-button>
                        <el-radio-button label="train">模块</el-radio-button>
                    </el-radio-group>
                </div>
                <div v-if="activeName == 'task'" key="a1">
                    <div class="">
                        <el-form :inline="true" :model="taskForm">
                            <div class="block">
                                <el-select
                                    v-model="taskForm.checkType"
                                    placeholder="选项"
                                    @change="changeOptions"
                                >
                                    <el-option
                                        label="平台"
                                        :value="true"
                                    ></el-option>
                                    <el-option
                                        label="学校"
                                        :value="false"
                                    ></el-option>
                                </el-select>
                                <el-cascader
                                    placeholder="任务知识点筛选"
                                    v-model="taskForm.knowledgeIds"
                                    :options="options"
                                    :props="{ expandTrigger: 'hover' }"
                                    @change="handleChange"
                                    style="width: 300px;margin-left: 20px;"
                                    clearable
                                >
                                </el-cascader>
                                <el-form-item
                                    label=""
                                    style="margin-left: 20px"
                                >
                                    <el-input
                                        v-model="taskForm.keywords"
                                        placeholder="请输入任务关键词"
                                        class="keyword_input"
                                        style="width: 300px;"
                                    >
                                        <i
                                            slot="suffix"
                                            class="el-input__icon el-icon-search font22 text_primary"
                                        ></i>
                                    </el-input>
                                </el-form-item>
                            </div>
                        </el-form>
                    </div>

                    <el-table
                        :data="taskData"
                        style="height:500px;overflow-y:visible"
                        @selection-change="handleChoose"
                        ref="libTable"
                    >
                        <el-table-column type="selection" width="55">
                        </el-table-column>
                        <el-table-column
                            property="date"
                            label="任务"
                            min-width="150"
                        >
                            <template slot-scope="scope">
                                {{ scope.row.title }}
                            </template>
                        </el-table-column>
                        <el-table-column
                            property="date"
                            label="编号"
                            min-width="150"
                        >
                            <template slot-scope="scope">
                                {{ scope.row.sn }}
                            </template>
                        </el-table-column>
                        <el-table-column
                            property="date"
                            label="知识点"
                            min-width="250"
                        >
                            <template slot-scope="scope">
                                <tag-group
                                    :tags="scope.row.knowledgeArray"
                                    size="medium"
                                ></tag-group>
                            </template>
                        </el-table-column>

                        <el-table-column width="500" label="资料">
                            <template slot-scope="scope">
                                <div class="grid col-4 hgap-5">
                                    <div
                                        class="fx fx-c_center"
                                        v-if="scope.row.videos.length > 0"
                                    >
                                        讲解视频：
                                        <el-button
                                            type="text"
                                            @click="
                                                setShowResources(
                                                    scope.row.videos
                                                )
                                            "
                                            size="medium"
                                            class="text_warn"
                                            >查看
                                        </el-button>
                                    </div>
                                    <div
                                        class="fx fx-c_center"
                                        v-if="scope.row.attachments.length > 0"
                                    >
                                        随堂资料：
                                        <el-button
                                            type="text"
                                            @click="
                                                setShowResources(
                                                    scope.row.attachments
                                                )
                                            "
                                            size="medium"
                                            class="text_warn"
                                            >查看
                                        </el-button>
                                    </div>
                                    <div
                                        class="fx fx-c_center"
                                        v-if="scope.row.codes.length > 0"
                                    >
                                        代码：
                                        <el-button
                                            type="text"
                                            @click="
                                                viewCodeDialog(
                                                    scope.row.codes[0].id
                                                )
                                            "
                                            size="medium"
                                            class="text_warn"
                                            >查看
                                        </el-button>
                                    </div>
                                    <div
                                        class="fx fx-c_center"
                                        v-if="scope.row.tutorials.length > 0"
                                    >
                                        卡片：
                                        <el-button
                                            type="text"
                                            @click="
                                                setShowResources(
                                                    scope.row.tutorials
                                                )
                                            "
                                            size="medium"
                                            class="text_warn"
                                            >查看
                                        </el-button>
                                    </div>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div v-if="activeName == 'question'" key="b1">
                    <div class="">
                        <el-form :inline="true" :model="form1">
                            <div class="block">
                                <!--<el-form-item label="选项">
                                        <el-select v-model="checkType" placeholder="选项" @change="changeOptions">
                                            <el-option label="平台" :value="true"></el-option>
                                            <el-option label="学校" :value="false"></el-option>
                                        </el-select>
                                    </el-form-item>-->
                                <el-form-item label="关键词">
                                    <el-input
                                        v-model="form1.keywords"
                                        placeholder="关键词"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item label="类型">
                                    <el-select
                                        v-model="form1.type"
                                        placeholder="类型"
                                        clearable
                                    >
                                        <el-option
                                            v-for="item in types"
                                            :key="item.optionValue"
                                            :label="item.optionText"
                                            :value="item.optionValue"
                                        >
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="分类">
                                    <el-select
                                        v-model="form1.categoryId"
                                        clearable
                                        placeholder="分类"
                                    >
                                        <el-option
                                            v-for="item in trainCategorys"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id"
                                        >
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="编程语言">
                                    <el-select
                                        v-model="form1.optType"
                                        clearable
                                        placeholder="全部"
                                        style="width: 120px"
                                    >
                                        <el-option
                                            v-for="item in lessonTypes"
                                            :key="item.optionValue"
                                            :label="item.optionText"
                                            :value="item.optionValue"
                                        >
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                        </el-form>
                    </div>
                    <el-table
                        :data="questionData"
                        stripe
                        style=" height:500px;overflow-y:visible"
                        @selection-change="handleChoose"
                        ref="libTable"
                    >
                        <el-table-column type="selection" width="55">
                        </el-table-column>
                        <el-table-column
                            min-width="180"
                            prop="questionFormHtml"
                            label="题目"
                        >
                        </el-table-column>
                        <el-table-column
                            min-width="120"
                            prop="categoryName"
                            label="分类"
                        >
                        </el-table-column>
                        <el-table-column min-width="120" label="标签">
                            <template slot-scope="scope">
                                <tag-group
                                    :tags="scope.row.tagNames"
                                ></tag-group>
                            </template>
                        </el-table-column>
                        <el-table-column
                            min-width="120"
                            prop="typeName"
                            label="类型"
                        >
                        </el-table-column>
                        <el-table-column
                            min-width="120"
                            prop="optName"
                            label="语言类型"
                        >
                        </el-table-column>
                        <el-table-column
                            property="date"
                            label="知识点"
                            min-width="250"
                        >
                            <template slot-scope="scope">
                                <tag-group
                                    :tags="scope.row.knowledgeArray"
                                    size="medium"
                                ></tag-group>
                            </template>
                        </el-table-column>
                        <el-table-column
                            min-width="120"
                            prop="score"
                            label="题目分数"
                        >
                        </el-table-column>
                    </el-table>
                </div>
                <div v-if="activeName == 'train'" key="c1">
                    <div class="">
                        <el-form :inline="true" :model="form2">
                            <div class="block">
                                <!--<el-form-item label="选项">
                                        <el-select v-model="checkType" placeholder="选项" @change="changeOptions">
                                            <el-option label="平台" :value="true"></el-option>
                                            <el-option label="学校" :value="false"></el-option>
                                        </el-select>
                                    </el-form-item>-->
                                <el-form-item label="关键词">
                                    <el-input
                                        v-model="form2.keywords"
                                        placeholder="关键词"
                                    ></el-input>
                                </el-form-item>
                            </div>
                        </el-form>
                    </div>
                    <el-table
                        :data="trainData"
                        stripe
                        style="height:500px;overflow-y:visible"
                        @selection-change="handleChoose"
                        ref="libTable"
                    >
                        <el-table-column type="selection" width="55">
                        </el-table-column>
                        <el-table-column
                            min-width="180"
                            prop="title"
                            label="题目"
                        >
                        </el-table-column>
                        <el-table-column width="160" label="封面">
                            <template slot-scope="scope">
                                <el-image
                                    style="width: 150px; height: 90px"
                                    :src="scope.row.imgPath"
                                    :lazy="true"
                                    :preview-src="scope.row.imgPath"
                                    fit="fill"
                                ></el-image>
                            </template>
                        </el-table-column>
                        <el-table-column
                            min-width="120"
                            prop="typeName"
                            label="类型"
                        >
                        </el-table-column>
                        <el-table-column
                            min-width="120"
                            prop="optName"
                            label="语言类型"
                        >
                        </el-table-column>
                        <el-table-column
                            min-width="120"
                            prop="categoryName"
                            label="分类"
                        >
                        </el-table-column>
                        <el-table-column min-width="120" label="标签">
                            <template slot-scope="scope">
                                <tag-group
                                    :tags="scope.row.tagNames"
                                ></tag-group>
                            </template>
                        </el-table-column>
                        <el-table-column
                            min-width="100"
                            prop="questionCount"
                            label="题目总数"
                        >
                        </el-table-column>
                        <el-table-column
                            min-width="100"
                            prop="difficulty"
                            label="难度"
                        >
                        </el-table-column>
                    </el-table>
                </div>
                <div class="panel_foot fx fx-m_end fx-c_center">
                    <el-pagination
                        :background="true"
                        prev-text="上一页"
                        next-text="下一页"
                        layout="prev, pager, next"
                        :current-page="pager.currentPage"
                        :page-size="pager.pageSize"
                        :total="pager.dataTotal"
                        @current-change="pageChange"
                    >
                    </el-pagination>
                </div>
                <span slot="footer" class="dialog-footer fx fx-center">
                    <el-button type="primary" @click="subAdd()"
                        >确认添加</el-button
                    >
                </span>
            </el-dialog>
        </template>

        <template>
            <el-dialog
                title="查看详情"
                :visible.sync="dialogTableDetailVisible"
                center
                width="40%"
                style="margin-top: -11vh;"
                class="task_dialog"
            >
                <div style="margin-bottom: 5px">
                    <el-form :inline="true" :model="taskDetailCountData">
                        <div class="block">
                            <span style="position: relative;left: 68px;">
                                总人数:{{ taskDetailCountData.studentCount }}
                            </span>
                            <span
                                style="position: relative;left: 25.5%;color: rgb(50 139 245);"
                            >
                                提交人数:{{ taskDetailCountData.commitCount }}
                            </span>
                            <span
                                style="position: relative;left: 40.5%;color: rgb(3 148 103);"
                            >
                                正确人数:{{ taskDetailCountData.correctCount }}
                            </span>
                            <span
                                style="position: relative;left: 55.4%;color: rgb(220 80 71);"
                            >
                                错误人数:{{ taskDetailCountData.errorCount }}
                            </span>
                        </div>
                    </el-form>
                </div>
                <el-table
                    :data="taskDetailData"
                    style="height:500px;overflow-y:visible"
                >
                    <el-table-column
                        property="date"
                        label="学生姓名"
                        min-width="150"
                    >
                        <template slot-scope="scope">
                            {{ scope.row.studentName }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        property="date"
                        label="选择答案"
                        min-width="150"
                    >
                        <template slot-scope="scope">
                            {{ scope.row.myAnswer }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        property="date"
                        label="正确答案"
                        min-width="150"
                    >
                        <template slot-scope="scope">
                            {{ scope.row.trainQuestionAnswer }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        property="date"
                        label="是否正确"
                        min-width="150"
                    >
                        <template slot-scope="scope">
                            {{ scope.row.result ? "√" : "×" }}
                        </template>
                    </el-table-column>
                </el-table>
            </el-dialog>
        </template>

        <template>
            <el-dialog
                title="查看详情"
                :visible.sync="dialogTableModuleDetailVisible"
                center
                width="40%"
                style="margin-top: -11vh;"
                class="task_dialog"
            >
                <div style="margin-bottom: 5px">
                    <el-form :inline="true" :model="taskModuleDetailCountData">
                        <div class="block">
                            <span style="position: relative;left: 68px;">
                                总人数:{{
                                    taskModuleDetailCountData.studentCount
                                }}
                            </span>
                            <span
                                style="position: relative;left: 25.5%;color: rgb(50 139 245);"
                            >
                                平均分:{{ taskModuleDetailCountData.avgScore }}
                            </span>
                            <span
                                style="position: relative;left: 40.5%;color: rgb(3 148 103);"
                            >
                                最高分:{{ taskModuleDetailCountData.maxScore }}
                            </span>
                            <span
                                style="position: relative;left: 58.4%;color: rgb(220 80 71);"
                            >
                                最低分:{{ taskModuleDetailCountData.minScore }}
                            </span>
                        </div>
                    </el-form>
                </div>
                <el-table
                    :data="taskModuleDetailData"
                    style="height:500px;overflow-y:visible"
                >
                    <el-table-column
                        property="date"
                        label="学生姓名"
                        min-width="150"
                    >
                        <template slot-scope="scope">
                            {{ scope.row.studentName }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        property="date"
                        label="答对题数"
                        min-width="150"
                    >
                        <template slot-scope="scope">
                            {{ scope.row.correctCount }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        property="date"
                        label="答错题数"
                        min-width="150"
                    >
                        <template slot-scope="scope">
                            {{ scope.row.errorCount }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        property="date"
                        label="得分"
                        min-width="150"
                    >
                        <template slot-scope="scope">
                            {{ scope.row.score }}
                        </template>
                    </el-table-column>
                </el-table>
            </el-dialog>
        </template>

        <ResourceDrawer
            :showBox="showResources"
            @play="play"
            @close="showResources = false"
            label="资源列表"
            :resources="currentResources"
        ></ResourceDrawer>
        <MyResourceDrawer
            :showBox="showMyResources"
            @play="play"
            @close="showMyResources = false"
            label="资源列表"
            :resources="currentMyResources"
        ></MyResourceDrawer>
        <VideoDrawer
            v-if="showVideo"
            @close="showVideo = false"
            :url="currentVideo"
        ></VideoDrawer>

        <StudentAttendanceDetailDrawer
            v-if="showStudentAttendance"
            :classid="currentLesson.id"
            @close="showStudentAttendance = false"
        ></StudentAttendanceDetailDrawer>
    </div>
</template>

<style scoped>

    .mask {
    	position: absolute;
    	top: 50px;
    	left: 0;
    	right: 0;
    	bottom: 0;
    	/* height:100%; */
    	background-color: #ffffff99;
    	/* 半透明遮罩层 */
    	/* pointer-events: none; */
    	/* 鼠标事件不被遮罩层捕获，直接传递到底层 */
    	z-index: 10;
    }

.nav_control {
    position: absolute;
    right: 10px;
    top: 50%;
    margin-top: -100px;
    width: 30px;
    height: 30px;
    background: white;
    border-radius: 50%;
    cursor: pointer;
}

.nav_control:hover {
    background: #00a0e9;
}

.nav_control:hover i {
    color: white;
}

.trysn_block {
    width: 190px;
    height: 50px;
    border-radius: 6px;
    background: rgb(227, 227, 227);
    font-size: 16px;
    margin-top: 15px;
    color: #3c3c3c;
}

.lesson_info {
    padding: 30px 40px;
    background: white;
}

.title {
    height: 50px;
    background: white;
    margin-bottom: 6px;
    font-size: 16px;
}

.lesson_nav {
    width: 300px;
    background: white;
    box-sizing: border-box;
    padding: 20px;
    position: relative;
    transition: width 0.3s;
}

.lesson_nav.shrink .shrink {
    display: none;
}

.lesson_nav.shrink {
    width: 60px;
}

.lesson_list {
    margin-top: 15px;
}

.lesson_item {
    height: 40px;
    box-sizing: border-box;
    padding: 0 30px 0 30px;
    font-size: 16px;
    cursor: pointer;
    margin: 4px 0;
}

.lesson_item.active {
    background: var(--primary);
    color: white;
}

.lesson_item i {
    font-size: 20px;
    font-weight: bold;
}

.lesson_item i.state3,
.lesson_item i.state2 {
    color: var(--primary);
}

.lesson_item.active i.state3,
.lesson_item.active i.state2 {
    color: white;
}

.lesson_item-name {
    display: block;
    max-width: 170px;
}

.lesson_item i.state1 {
    color: var(--lighter);
}

.lesson_opt {
    width: 290px;
    background: white;
}

.task_panel {
    background: white;
}

.task_resource {
    margin-right: 10px;
}

.keyword_input >>> input {
    background: white;
}

.task_dialog >>> .el-dialog {
    border-radius: 16px;
    overflow: hidden;
}
</style>

<script>
import ResourceDrawer from "@/components/ResourceDrawer";
import VideoDrawer from "@/components/VideoDrawer";
import StudentAttendanceDetailDrawer from "./StudentAttendanceDetailDrawer";
import MyResourceDrawer from "./ResourceDrawer";

import { mapMutations } from "vuex";

export default {
    components: {
        ResourceDrawer,
        VideoDrawer,
        StudentAttendanceDetailDrawer,
        MyResourceDrawer
    },
    props: [
        "attr" // {classId, classLessonId, isSelf}
    ],
    data() {
        return {
            navShrink: false, //是否收起课程列表
            // authorize:true,
            taskData: [],
            questionData: [],
            form1: { keywords: "" },
            trainData: [],
            trainModuleTypes: [],
            form2: { keywords: "", type: 1 },
            taskForm: {
                keywords: "",
                knowledgeIds: [],
                checkType: true,
                enable: true,
                relevance: false
            },
            choosedList: [],
            dialogTableVisible: false,
            loading: false,
            showResources: false,
            showMyResources: false,
            showVideo: false,
            currentResources: [],
            currentMyResources: [],
            currentVideo: null,

            isSelf: this.attr ? this.attr.isSelf == true : false, //是否只看自己教任的班级

            classId: this.attr ? this.attr.classId : 0,

            classLessonId: this.attr ? this.attr.classLessonId : 0,

            classes: [], //班级列表

            showStudentAttendance: false,

            //计时器，用于显示已上课时间
            timer: null,

            classLessons: [],

            //定时器， 定时刷新课程相关数据
            refreshTimer: null,
            defaultProps: {
                children: "children",
                label: "name",
                value: "id",
                disabled: true
            },
            options: [],
            pager: {
                pageSize: 12,
                dataTotal: 0,
                currentPage: 1
            },
            activeName: "task",
            types: [],
            trainCategorys: [],
            trainTags: [],

            dialogTableDetailVisible: false,
            taskDetailCountData: {},
            taskDetailData: [],
            dialogTableModuleDetailVisible: false,
            taskModuleDetailCountData: {},
            taskModuleDetailData: [],
            lessonTypes: []
        };
    },
    watch: {
        classId: {
            handler: function() {
                this.classLessonId = 0; //切换班级时，重置lessonId,不然新班级可能无法定位到当前课程
                this.loadLessons();
                this.taskForm.knowledgeIds = [];
                this.taskForm.checkType = true;
            }
        },
        taskForm: {
            handler: function(newValue) {
                this.pager.currentPage = 1;
                if (this.taskForm.checkType) {
                    this.loadTaskData();
                } else {
                    this.loadSchoolTaskData();
                }
                //this.loadTaskData();
            },
            deep: true
        },
        form1: {
            handler: function(newValue) {
                this.pager.currentPage = 1;
                this.loadQuestionData();
            },
            deep: true
        },
        form2: {
            handler: function(newValue) {
                this.pager.currentPage = 1;
                this.loadTrainModuleData();
            },
            deep: true
        },
        activeName: {
            handler: function(newValue) {
                this.pager = {
                    pageSize: 12,
                    dataTotal: 0,
                    currentPage: 1
                };
                if (this.activeName == "task") {
                    this.loadTaskData();
                }
                if (this.activeName == "question") {
                    this.loadTypes();
                    this.loadTrainCategory();
                    this.loadQuestionData();
                    this.loadLessonTypes();
                }
                if (this.activeName == "train") {
                    this.loadTrainModuleTypes();
                    this.loadTrainModuleData();
                }
            },
            deep: true
        },
        classLessonId: {
            handler: function(newValue) {
                //清除上课时长计时器
                if (this.timer != null) {
                    window.clearInterval(this.timer);
                }
                //清除上课数据刷新 定时器
                if (this.refreshTimer != null) {
                    window.clearInterval(this.refreshTimer);
                }
                if (this.currentLesson.state == 3) {
                    this.$set(
                        this.currentLesson,
                        "duration",
                        calDuration(
                            this.currentLesson.startTime,
                            this.currentLesson.endTime
                        )
                    );
                } else if (this.currentLesson.state == 2) {
                    this.$set(
                        this.currentLesson,
                        "duration",
                        calDuration(
                            this.currentLesson.startTime,
                            new Date().getTime()
                        )
                    );
                    this.startTimer();
                }

                this.startRefreshTimer();
            },
            immediate: true
        }
    },
    computed: {
        currentLesson: function() {
            let defaultLesson = {
                lessonCoverImg:
                    "http://assets.atomarrow.net/work/demo_cover1.png"
            };
            let lesson = null;
            if (this.classLessonId && this.classLessons.length > 0) {
                lesson = this.classLessons.filter(
                    item => item.id == this.classLessonId
                )[0];
            }
            return lesson == null ? defaultLesson : lesson;
        },
        currentClass: function() {
            if (this.classId && this.classes.length > 0) {
                return this.classes.filter(item => item.id == this.classId)[0];
            }
            return {};
        }
    },

    methods: {
        ...mapMutations(["openTab"]),

        changeClassLesson(item) {
            this.classLessonId = item.id;
            // this.navShrink = true;
        },
        // getAuthorize(){
        //     this.$ajaxGet("/lesson/getAuthorize/"+this.lessonSystem.id, (data) => {
        //         this.authorize = data.result;
        //     })
        // },
        handleClick(tab, event) {
            this.toActiveName(tab.name);
        },
        pageChange(page) {
            this.pager.currentPage = page;
            if (this.activeName == "task") {
                if (this.taskForm.checkType) {
                    this.loadTaskData();
                } else {
                    this.loadSchoolTaskData();
                }
            } else if (this.activeName == "question") {
                this.loadQuestionData();
            } else if (this.activeName == "train") {
                this.loadTrainModuleData();
            }
        },
        handleChange(value) {
            console.log(value);
        },
        setShowResources(resources) {
            this.currentResources = resources;
            this.showResources = true;
        },
        setShowMyResources(resources) {
            this.currentMyResources = [];
            let data = [
                {
                    linkId: this.currentLesson.lessonId,
                    linkType: 1,
                    category: 5
                }
            ];
            this.currentMyResources = resources.length == 0 ? data : resources;
            this.showMyResources = true;
        },
        play(url) {
            this.currentVideo = url;
            this.showVideo = true;
        },
        showTaskWorks(task) {
            if (task.useType == 1) {
                this.openTab({
                    funcKey: "school_menu_taskwork_manage",
                    title: "任务作品详情",
                    attr: {
                        classId: this.currentClass.id,
                        classLessonTaskId: task.id,
                        isSelf: this.isSelf
                    },
                    allowDuplicate: true
                });
            }
            if (task.useType == 2) {
                this.dialogTableDetailVisible = true;
                this.$ajaxPost(
                    "/classLessonAnswer/getDetail",
                    {
                        classId: this.currentClass.id,
                        classLessonId: task.classLessonId,
                        questionId: task.question.id
                    },
                    data => {
                        this.taskDetailCountData = data.result;
                    }
                );
                this.$ajaxPost(
                    "/classLessonAnswer/list",
                    {
                        classLessonId: task.classLessonId,
                        questionId: task.question.id
                    },
                    data => {
                        this.taskDetailData = data.result;
                    }
                );
            }
            if (task.useType == 3) {
                this.dialogTableModuleDetailVisible = true;
                this.$ajaxPost(
                    "/classLessonAnswer/getModuleDetail",
                    {
                        classId: this.currentClass.id,
                        classLessonId: task.classLessonId,
                        moduleId: task.module.id
                    },
                    data => {
                        this.taskModuleDetailCountData = data.result;
                    }
                );
                this.$ajaxPost(
                    "/classLessonAnswer/listModule",
                    {
                        classLessonId: task.classLessonId,
                        moduleId: task.module.id
                    },
                    data => {
                        this.taskModuleDetailData = data.result;
                    }
                );
            }
        },
        toCode() {
            this.$goEditCode(this.currentLesson.lessonType);
            // top.window.open("/scratch/");
        },
        showAttendanceDetail() {
            this.showStudentAttendance = true;
        },
        startTimer() {
            this.timer = setInterval(() => {
                this.$set(
                    this.currentLesson,
                    "duration",
                    calDuration(
                        this.currentLesson.startTime,
                        new Date().getTime()
                    )
                );
            }, 1000);
        },
        startLesson() {
            let classLessonId = this.currentLesson.id;
            this.$ajaxGet("/classLesson/startLesson/" + classLessonId, data => {
                this.currentLesson.startTime = new Date().getTime();
                this.currentLesson.state = 2;
                this.startTimer();
                this.currentClass.currentLessonId = classLessonId;
            });
        },

        stopLesson() {
            this.$ajaxGet(
                "/classLesson/endLesson/" + this.currentLesson.id,
                data => {
                    this.currentLesson.endTime = new Date().getTime();
                    this.currentLesson.state = 3;
                    window.clearInterval(this.timer);
                    this.timer = null;
                }
            );
        },
        modifyTaskEnable(task) {
            this.$ajaxGet(
                "/classLessonTask/toggleEnable/" + task.id + "-" + task.enable
            );
        },

        loadTasks(classLesson) {
            this.$ajaxGet("/classLessonTask/list/" + classLesson.id, data => {
                data.result.forEach(item => {
                    (item.videos = item.resources
                        ? item.resources.filter(i => i.category == 1)
                        : []),
                        (item.codes = item.resources
                            ? item.resources.filter(i => i.category == 3)
                            : []),
                        (item.tutorials = item.resources
                            ? item.resources.filter(i => i.category == 4)
                            : []),
                        (item.attachments = item.resources
                            ? item.resources.filter(i => i.category == 2)
                            : []),
                        (item.linkCodes = item.linkResources.filter(
                            r => r.category == 4
                        ));
                         // console.log(item);
                }

                );
                this.$set(classLesson, "tasks", data.result);
            });
        },
        loadLessons() {
            this.loading = true;
            if (!this.classId) {
                this.classLessons = [];
                this.loading = false;
            } else {
                let originClassLessonId = this.classLessonId;
                this.classLessonId = 0;
                this.$ajaxGet("/classLesson/list/" + this.classId, data => {
                    data.result.forEach(item => {
                        item.videos = item.resources.filter(
                            r => r.category == 1
                        );
                        item.plans = item.resources.filter(
                            r => r.category == 2
                        );
                        item.ppts = item.resources.filter(r => r.category == 3);
                        item.codes = item.resources.filter(
                            r => r.category == 4
                        );
                        item.myPlans = item.resources.filter(
                            r => r.category == 5
                        );
                        item.tasks = null;
                    });
                    this.classLessons = data.result;

                    this.loading = false;
                    //显示哪节课，优先显示attr传进来的课，然后班级当前课
                    this.classLessonId =
                        originClassLessonId ||
                        this.currentClass.currentLessonId;
                    if (!this.classLessonId && this.classLessons.length > 0) {
                        this.classLessonId = this.classLessons[0].id;
                    }
                    if (this.classLessonId) {
                        this.$nextTick(function() {
                            this.focusLesson(this.classLessonId);
                        });
                    }
                });
            }
        },
        focusLesson(classLessonId) {
            //定位到课程位置
            let offsetHeight = this.$refs["lesson_list"].offsetHeight;
            let itemTop = this.$refs["lesson_item" + classLessonId][0]
                .offsetTop;
            this.$refs["lesson_list"].scrollTop = itemTop - offsetHeight + 500;
        },
        loadClasses() {
            let url = null;
            if (this.isSelf) {
                url = "/class/listSelf";
            } else {
                url = "/class/list";
            }
            this.$ajaxPost(
                url,
                {
                    form: {
                        enable: true,
                        hasEnable: true
                    }
                },
                data => {
                    this.classes = data.result;
                    if (!this.classId && this.classes && this.classes.length) {
                        this.classId = this.classes[0].id;
                    }
                }
            );
        },
        handleClassChange(classId) {
            this.classId = classId;
        },
        loadLessonTypes() {
            this.$ajaxGet("/common/lessonTypeByExamQuestion", data => {
                this.lessonTypes = data.result;
            });
        },
        copyLesson() {
            this.$ajaxGet(
                "/classLesson/copyAndStartLesson/" + this.currentLesson.id,
                data => {
                    this.classLessonId = data.result.id;
                    this.loadLessons();
                }
            );
        },
        viewCode(id) {
            // this.$goEditCode(this.currentLesson.lessonType, `isplatform=&mode=caseview&id=${id}`);
            //isplatform=&  这个加了之后学校的打不开 先去掉
            //let url = this.taskForm.checkType ? `isplatform=true&mode=caseview&id=${id}` : `mode=caseview&id=${id}`;
            this.$goEditCode(
                this.currentLesson.lessonType,
                `mode=caseview&id=${id}`
            );
        },
        viewCodeDialog(id) {
            let url = this.taskForm.checkType
                ? `isplatform=true&mode=caseview&id=${id}`
                : `mode=caseview&id=${id}`;
            this.$goEditCode(this.currentLesson.lessonType, url);
        },
        //开始定时刷新课程的数据,15s刷一次
        startRefreshTimer() {
            if (!this.currentLesson.id) return; //默认数据不做任何处理
            this.loadTasks(this.currentLesson);
            this.refreshLessonDetail();

            this.refreshTimer = setInterval(this.refreshLessonDetail(), 15000);
        },

        //刷新课程详情
        refreshLessonDetail() {
            console.debug("开始刷新课程详情");
            let lesson = this.currentLesson;
            this.loadTasks(lesson);

            this.$ajaxGet(`/classLesson/getOne/${lesson.id}`, data => {
                const success = data.success || false;
                if (success) {
                    lesson.attendanceStudentIds =
                        data.result.attendanceStudentIds;
                    lesson.studentIds = data.result.studentIds;
                    lesson.tryStudentCount = data.result.tryStudentCount;
                    lesson.studentCount = data.result.studentCount;
                    lesson.attendanceStudentCount =
                        data.result.attendanceStudentCount;
                }
            });

            return this.refreshLessonDetail;
        },
        openTask() {
            this.taskForm.keywords = "";
            this.dialogTableVisible = true;
            this.taskForm.checkType = true; //添加任务 默认平台
            this.loadTaskData();
        },
        loadTaskData() {
            if (this.dialogTableVisible == false) {
                return;
            }
            this.loadFuncs();
            this.taskForm.type = this.currentLesson.lessonType;
            this.$ajaxPost(
                "/lessonTask/listByPlatFormId",
                {
                    form: this.taskForm,
                    pager: { ...this.pager, dataTotal: 0 }
                },
                data => {
                    let { offset, ...pager } = data.pager;
                    this.pager = pager;
                    let items = data.result;
                    items.forEach(item => {
                        item.videos = item.resources.filter(
                            r => r.category == 1
                        );
                        item.attachments = item.resources.filter(
                            r => r.category == 2
                        );
                        item.codes = item.resources.filter(
                            r => r.category == 3
                        );
                        item.tutorials = item.resources.filter(
                            r => r.category == 4
                        );
                    });
                    this.taskData = items;
                    this.activeName = "task";
                    // this.dialogTableVisible = true;
                }
            );
        },
        loadSchoolTaskData() {
            if (this.dialogTableVisible == false) {
                return;
            }
            this.loadFuncs();
            this.taskForm.type = this.currentLesson.lessonType;
            this.$ajaxPost(
                "/lessonTask/listBySchoolId",
                {
                    form: this.taskForm,
                    pager: { ...this.pager, dataTotal: 0 }
                },
                data => {
                    let items = data.result;
                    let { offset, ...pager } = data.pager;
                    this.pager = pager;
                    items.forEach(item => {
                        item.videos = item.resources.filter(
                            r => r.category == 1
                        );
                        item.attachments = item.resources.filter(
                            r => r.category == 2
                        );
                        item.codes = item.resources.filter(
                            r => r.category == 3
                        );
                        item.tutorials = item.resources.filter(
                            r => r.category == 4
                        );
                    });
                    this.taskData = items;
                    // this.dialogTableVisible = true;
                }
            );
        },
        changeOptions() {
            this.taskData = [];
            this.pager = {
                pageSize: 12,
                dataTotal: 0,
                currentPage: 1
            };
            if (this.taskForm.checkType) {
                this.loadTaskData();
            } else {
                this.loadSchoolTaskData();
            }
        },
        handleChoose(val) {
            this.choosedList = val;
        },
        subAdd() {
            let modules = [];
            if (this.activeName == "task") {
                modules = this.choosedList.map(item => {
                    return {
                        title: item.title,
                        type: item.type,
                        useType: 1,
                        knowledgeIds: item.knowledgeIds,
                        resources: item.resources,
                        linkId: item.linkId
                    };
                });
            } else if (this.activeName == "question") {
                modules = this.choosedList.map(item => {
                    return {
                        linkId: item.id,
                        //title: item.title,
                        useType: 2,
                        knowledgeIds: item.knowledgeIds
                    };
                });
            } else if (this.activeName == "train") {
                modules = this.choosedList.map(item => {
                    return {
                        linkId: item.id,
                        //title: item.title,
                        useType: 3,
                        knowledgeIds: item.knowledgeIds
                    };
                });
            }
            if (modules.length == 0) {
                this.$showError("请选择训练");
                return;
            }
            this.$ajaxPost(
                "/lessonTask/addLessonTasksAndTrainQuestions",
                {
                    classLessonId: this.classLessonId,
                    classId: this.classId,
                    list: modules
                },
                data => {
                    this.$showSuccess("添加成功");
                    this.loadTasks(this.currentLesson);
                    this.dialogTableVisible = false;
                    this.$emit("close");
                }
            );
        },
        remove(item) {
            this.$ajaxPost(
                "/classLessonTask/delClassLessonTask",
                {
                    taskId: item.taskId,
                    classId: item.classId,
                    classLessonId: item.classLessonId
                },
                data => {
                    this.loadTasks(this.currentLesson);
                }
            );
        },
        loadFuncs() {
            this.taskForm.type = this.currentLesson.lessonType;
            this.$ajaxPost(
                "/knowledge/knowledgeByTask",
                { form: this.taskForm },
                data => {
                    //knowledgeTree
                    this.options = data.result;
                }
            );
        },
        loadTrainCategory() {
            let url =
                this.checkType == true
                    ? "/trainCategory/listOption/1"
                    : "/trainCategory/listOptionByAll/1";
            this.$ajaxGet(url, data => {
                this.trainCategorys = data.result;
            });
        },
        loadTrainTag() {
            let url =
                this.checkType == true
                    ? "/trainCategory/listOption/2"
                    : "/trainCategory/listOptionByAll/2";
            this.$ajaxGet(url, data => {
                this.trainTags = data.result;
            });
        },
        loadTypes() {
            this.$ajaxGet("/trainQuestion/questionTypes", data => {
                this.types = data.result;
            });
        },
        loadTrainModuleTypes() {
            this.$ajaxGet("/common/trainModuleType", data => {
                this.trainModuleTypes = data.result;
            });
        },
        loadQuestionData() {
            //let url = this.checkType == true ? "/trainQuestion/listByPlatform" : "/trainQuestion/list";
            let url = "/trainQuestion/list";
            this.$ajaxPost(
                url,
                {
                    form: this.form1,
                    pager: { ...this.pager, dataTotal: 0 }
                },
                data => {
                    //分页不能带offset，否则会影响后台计算最新offset
                    let { offset, ...pager } = data.pager;
                    this.pager = pager;
                    this.questionData = data.result;
                    this.activeName = "question";
                }
            );
        },
        loadTrainModuleData() {
            //let url = this.checkType == true ? "/trainModule/listByPlatform" : "/trainModule/list";
            let url = "/trainModule/list";
            this.$ajaxPost(
                url,
                {
                    form: this.form2,
                    pager: { ...this.pager, dataTotal: 0 }
                },
                data => {
                    //分页不能带offset，否则会影响后台计算最新offset
                    let { offset, ...pager } = data.pager;
                    this.pager = pager;
                    this.trainData = data.result;
                    this.activeName = "train";
                }
            );
        },
        toActiveName(name) {
            this.pager = {
                pageSize: 12,
                dataTotal: 0,
                currentPage: 1
            };
            if (name == "task") {
                this.loadTaskData();
            }
            if (name == "question") {
                this.loadTypes();
                this.loadTrainCategory();
                this.loadQuestionData();
                this.loadLessonTypes();
            }
            if (name == "train") {
                this.loadTrainModuleTypes();
                this.loadTrainModuleData();
            }
        },
        startAllLessons() {
            if (!this.classId) return;
            //开启该班级所有课程
            this.$showConfirm("确认将该班级的所有课程开启吗？", () => {
                this.$ajaxGet("/classLesson/startClassAllLesson/" + this.classId, data => {
                    this.loadLessons()
                });
            })
        },
    },

    created() {
        this.loadClasses();
        this.loadLessons();
        this.loadFuncs();
    },
    beforeDestroy() {
        if (this.timer != null) {
            window.clearInterval(this.timer);
        }
        if (this.refreshTimer != null) {
            window.clearInterval(this.refreshTimer);
        }
    }
};

/**
 * 计时
 * @param startTime
 * @param endTime
 * @returns {{days: number}}
 */
function calDuration(startTime, endTime) {
    let diff = Math.floor(endTime / 1000 - startTime / 1000);
    let days = Math.floor(diff / 60 / 60 / 24);
    let hours = Math.floor((diff / 60 / 60) % 24);
    let minutes = Math.floor((diff / 60) % 60);
    let seconds = Math.floor(diff % 60);
    return {
        days: days,
        hours: hours === 0 ? "0" : hours < 10 ? "0" + hours : hours,
        minutes: minutes < 10 ? "0" + minutes : minutes,
        seconds: seconds < 10 ? "0" + seconds : seconds
    };
}
</script>
